import { PasswordField } from 'src/pages/channel/shared';

import { Field } from 'src/components/hook-form';

export const LineFields = ({ t }: any) => (
  <>
    <Field.Text
      name="lineChannelId"
      label={t('LINE_CHANNELID')}
      InputLabelProps={{ shrink: true }}
      placeholder={t('ENTER_LINE_CHANNEL_ID')}
    />
    <PasswordField
      name="lineChannelSecret"
      label={t('LINE_CHANNEL_SECRET')}
      placeholder={t('ENTER_LINE_CHANNEL_SECRET')}
    />
  </>
);
